var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"additional-info"},[_c('SectionHeader',{attrs:{"title":"Additional Info","extra-class":['text-left']}}),_c('div',{staticClass:"info-list"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.InfoData)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }